<template>
  <div class="tfMiniapp">
    <el-card>
      <span class="label">公众号名称: </span>
      <el-input size="small" v-model="filter.wechatpubName" placeholder="请输入公众号名称" style="width: 150px"></el-input>
      <span class="label">所属小程序</span>
      <el-select size="small" v-model="filter.miniprogramId">
        <el-option v-for="item in applist" :key="item.id" :value="item.id" :label="item.miniprogramName"></el-option>
      </el-select>

      <el-button size="small" type="primary" style="margin: 0 10px 0 20px" @click="initPage">查询</el-button>
      <el-button size="small" @click="reset">重置</el-button>
      <br>
      <el-button size="small" type="primary" style="margin-top: 10px" @click="dialogVisible = true">添加</el-button>

      <el-table :data="list" border style="margin-top: 10px">
        <el-table-column align="center" label="渠道链接" prop="">
          <template slot-scope="scope">
            <span v-if="scope.row.miniprogramPath && scope.row.miniprogramPath.indexOf('?') > -1">{{ scope.row.miniprogramPath + `&sid=${scope.row.id}` }}</span>
            <span v-else-if="scope.row.miniprogramPath">{{ scope.row.miniprogramPath + `?sid=${scope.row.id}` }}</span>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="所属小程序" prop="miniprogramName"></el-table-column>
        <el-table-column align="center" label="统计公众号名称" prop="wechatpubName"></el-table-column>
        <el-table-column align="center" label="统计文章标题" prop="articleTitle"></el-table-column>
        <el-table-column align="center" label="最后更新时间" prop="lastUpdateDate"></el-table-column>
        <el-table-column align="center" label="最后修改人" prop="lastUpdateName"></el-table-column>
        <el-table-column align="center" label="操作" prop="">
          <template slot-scope="scope">
            <a href="javascript:;" @click="edit(scope.row)">编辑</a> &nbsp;
            <a href="javascript:;" @click="delMChannel(scope.row)">删除</a>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        style="text-align: center; margin-top: 10px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="filter.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="filter.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-card>

    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
      <el-form ref="form" :model="formItem" :rules="rules" label-width="100px">
        <el-form-item label="选择小程序: " prop="miniprogramId">
          <el-select size="small" v-model="formItem.miniprogramId">
            <el-option v-for="item in applist" :key="item.id" :value="item.id" :label="item.miniprogramName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="小程序路径: " prop="miniprogramPath">
          <el-input v-model="formItem.miniprogramPath" :disabled="!!formItem.id" size="small" placeholder="请输入小程序路径"></el-input>
        </el-form-item>
        <el-form-item label="公众号名称: " prop="wechatpubName">
          <el-input v-model="formItem.wechatpubName" size="small" placeholder="请输入公众号名称"></el-input>
        </el-form-item>
        <el-form-item label="文章标题: " prop="articleTitle">
          <el-input v-model="formItem.articleTitle" size="small" placeholder="请输入文章标题"></el-input>
        </el-form-item>
        <el-form-item label="" prop="">
          <el-button size="small" @click="handleClose">取消</el-button>
          <el-button type="primary" size="small" @click="save">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getAllList, getListPage, addMChannel, updateMChannel, delMChannel } from '@/api/season/tfMiniapp'
export default {
  name: 'TfMiniapp',
  data () {
    return {
      filter: {
        page: 1,
        limit: 10,
        wechatpubName: '',
        miniprogramId: ''
      },
      applist: [],
      list: [],
      total: 0,
      dialogVisible: false,
      title: '创建渠道链接',
      formItem: {
        id: '',
        miniprogramId: '',
        miniprogramPath: '',
        wechatpubName: '',
        articleTitle: ''
      },
      rules: {
        miniprogramId: [{ required: true, message: '请选择小程序', trigger: 'change' }],
        miniprogramPath: [{ required: true, message: '请输入小程序路径', trigger: 'blur' }],
        wechatpubName: [{ required: true, message: '请输入公众号名称', trigger: 'blur' }],
        articleTitle: [{ required: true, message: '请输入文章标题', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.init()
    this.getListPage()
  },
  methods: {
    initPage() {
      this.filter.page = 1
      this.getListPage()
    },
    reset() {
      this.filter = {
        page: 1,
        limit: 10,
        wechatpubName: '',
        miniprogramId: ''
      }
      this.getListPage()
    },
    async init () {
      const res = await getAllList()
      this.applist = res.data
    },
    async getListPage() {
      const res = await getListPage(this.filter)
      this.list = res.data.records
      this.total = +res.data.total
    },
    edit(row) {
      Object.keys(this.formItem).forEach(key => {
        this.formItem[key] = row[key]
      })
      this.title = '编辑渠道链接'
      this.dialogVisible = true
    },
    save() {
      this.$refs['form'].validate(async(valid) => {
        if (valid) {
          const miniprogramName = this.applist.find(col => col.id === this.formItem.miniprogramId).miniprogramName
          if (this.formItem.id) {
            const res = await updateMChannel({...this.formItem, miniprogramName})
          } else {
            const res = await addMChannel({...this.formItem, miniprogramName})
          }
          this.$message.success('操作成功! ')
          this.handleClose()
          this.initPage()
        } else {
        }
      });
    },
    delMChannel(row) {
      this.$confirm('确定要删除当前参数码吗？删除后将不会在进行统计公众号名称和文章标题，之前统计的也将会进行消失，请谨慎操作！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        const res = await delMChannel({id: row.id})
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
        this.initPage()
      }).catch(() => {})
    },
    handleCurrentChange(v) {
      this.filter.page = v
      this.getListPage()
    },
    handleSizeChange(v) {
      this.filter.limit = v
      this.filter.page = 1
      this.getListPage()
    },
    handleClose() {
      this.$refs['form'].resetFields()
      this.dialogVisible = false
      this.formItem.id = ''
      this.title = '创建渠道链接'
    }
  }
}
</script>

<style lang="scss" scoped>
.tfMiniapp {
  span.label {
    display: inline-block;
    width: 100px;
    text-align: right;
    margin-right: 10px;
  }
}
</style>
